import React, { Component } from "react";
import Facts from './facts';
import './index.css';
import img from './img/credible.png';

class App extends Component {

  constructor(props) {
    super(props);
    this.state = {
      apikey: "AIzaSyBUCu4ClBlqTboY9EYpCNmcwuN62b7U6No",
      items: [],
      isLoaded: false,
      fact: "",
      lang: "",
      url: "https://factchecktools.googleapis.com/v1alpha1/claims:search?key=",
      nextPage: undefined,
    };
    // This binding is necessary to make `this` work in the callback
    this.handleInputChange = this.handleInputChange.bind(this);
    this.datafetch = this.datafetch.bind(this);
  }

  componentDidMount() {
    document.getElementById("search").addEventListener("click", Event => {
      Event.preventDefault();
      this.state.url = this.state.url + this.state.apikey + '&query=' + this.state.fact + '&languageCode=' + this.state.lang;
      this.datafetch(this.state.url);
    });
    document.getElementById("nextPage").addEventListener("click", Event => {
      Event.preventDefault();
      let url1 = this.state.url + "&pageToken=" + this.state.nextPage;
      this.datafetch(url1);
    });
  }

  datafetch(url) {
    console.log(url);
    fetch(url)
      .then(response => response.json()) //to get the response and as response will be asynchronous so it will be passed to next then whenever we get it
      .then(content => {
        this.setState({
          isLoaded: true,
          items: content.claims,
          fact: "",
          lang: "",
          nextPage: content.nextPageToken,
        })
        console.log(content.claims);
        console.log('Next Page', content.nextPageToken);
      }) //to handle the data. JSON response will have claims and nextPageToken(just two properties)
      .catch(err => {
        console.error(err);
      });
  }

  handleInputChange(event) {
    let target = event.target;
    let name = target.id;

    this.setState({
      [name]: target.value
    });
  }


  render() {
    var { isLoaded, items, nextPage } = this.state;
    let str;
    if (nextPage == undefined)
      str = "hidden";
    else
      str = "visible";
    if (!isLoaded && nextPage == undefined) {
      return (
        <React.Fragment>
          <div className="fact-wrapper">
            <form action="" className="form">
              <img src={img} alt="" />
              <h1>Credible</h1>
              <div className="input-group">
                <input type="text" id="fact" placeholder="Fact" value={this.state.fact} onChange={this.handleInputChange} />
                <label>Fact</label>
              </div>
              <div className="input-group">
                <input type="text" id="lang" value="English" onChange={this.handleInputChange} />
                <label>Language</label>
                <button id="search" className="search-btn">Search</button>
                <button className="nextbutton" id="nextPage" style={{ visibility: `${str}` }}>Next Page</button>
              </div>
            </form>
          </div>
        </React.Fragment>);
    }
    else if (isLoaded && items != undefined) {
      return (
        <React.Fragment>
          <div className="fact-wrapper">
            <form action="" className="form">
              <img src={img} alt="" />
              <h1>Credible</h1>
              <div className="input-group">
                <input type="text" id="fact" placeholder="Fact" value={this.state.fact} onChange={this.handleInputChange} />
                <label>Fact</label>
              </div>
              <div className="input-group">
                <input type="text" id="lang" value="English" onChange={this.handleInputChange} />
                <label>Language</label>
                <button id="search" className="search-btn">Search</button>
                <button className="nextbutton" id="nextPage" style={{ visibility: `${str}` }}>Next Page</button>
              </div>
            </form>
          </div>
          <ol className="gradient-list">
            {items.map(item => {
              return (
                <li><Facts
                  claimant={item.claimant}
                  text={item.text}
                  textualRating={item.claimReview[0].textualRating}
                  url={item.claimReview[0].url}
                  reviewDate={item.claimReview[0].reviewDate}
                /></li>
              );
            })}
          </ol>
        </React.Fragment>);
    }
    else if (isLoaded && items == undefined) {
      return (
        <React.Fragment>
          <div className="fact-wrapper">
            <form action="" className="form">
              <img src={img} alt="" />
              <h1>Credible</h1>
              <div className="input-group">
                <input type="text" id="fact" placeholder="Fact" value={this.state.fact} onChange={this.handleInputChange} />
                <label>Fact</label>
              </div>
              <div className="input-group">
                <input type="text" id="lang" value="English" onChange={this.handleInputChange} />
                <label>Language</label>
                <button id="search" className="search-btn">Search</button>
                <button id="nextPage" hidden={true}>Next Page</button>
              </div>
            </form>
          </div>
          <div className="noresult">
            <p>Your Search did not match any claims.</p>
            <p>Suggestions:</p>
            <ul style={{ paddingLeft: "50px" }}>
              <li>Make sure all keywords are spelled correctly.</li>
              <li>Try different keywords.</li>
              <li>Try more general keywords.</li>
              <li>Try fewer keywords.</li>
            </ul>
          </div>
        </React.Fragment>);
    }
  }
}

export default App;